import axios from 'axios';
import * as actionTypes from './actionTypes';

export const packagesLoading = () => {
    return {
        type: actionTypes.PACKAGES_LOADING
    }
};

export const packagesFail = (error) => {
    return {
        type: actionTypes.PACKAGES_FAIL,
        error: error
    }
};

export const packagesSuccess = (data) => {
    return {
        type: actionTypes.PACKAGES_SUCCESS,
        payload: data
    }
};

export const subPackagesLoading = () => {
    return {
        type: actionTypes.SUB_PACKAGES_LOADING
    }
};

export const subPackagesFail = (error) => {
    return {
        type: actionTypes.SUB_PACKAGES_FAIL,
        error: error
    }
};

export const subPackagesSuccess = (data) => {
    return {
        type: actionTypes.SUB_PACKAGES_SUCCESS,
        payload: data
    }
};


export const packagesList = (token, server) => {
    return dispatch => {
        dispatch(packagesLoading());
        console.log('LOGGING packagesList', server);
        axios.get('/api/packages?token=' + token + '&server=' + server)
            .then(res => {
                console.log(res);
                dispatch(packagesSuccess(res.data));
            }).catch(error => {
            dispatch(packagesFail(error));
        });
    }
};

export const packagesListAdmin = (token, server) => {
    return dispatch => {
        dispatch(packagesLoading());
        axios.get('/admin/packages?token=' + token + '&server=' + server )
            .then(res => {
                console.log(res);
                dispatch(packagesSuccess(res.data));
            }).catch(error => {
            dispatch(packagesFail(error));
        });
    }
};

export const packagesListSuperReseller = (token, server) => {
    return dispatch => {
        dispatch(packagesLoading());
        axios.get('/superreseller/packages?token=' + token + '&server=' + server )
            .then(res => {
                console.log(res);
                dispatch(packagesSuccess(res.data));
            }).catch(error => {
            dispatch(packagesFail(error));
        });
    }
};

export const packagesListReseller = (token, server) => {
    return dispatch => {
        dispatch(packagesLoading());
        axios.get('/reseller/packages?token=' + token + '&server=' + server )
            .then(res => {
                console.log(res);
                dispatch(packagesSuccess(res.data));
            }).catch(error => {
            dispatch(packagesFail(error));
        });
    }
};

export const subPackagesList = (token, name, server) => {
    return dispatch => {
        dispatch(subPackagesLoading());
        axios.get('/api/subpackages/' + name + '/' + server + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(subPackagesSuccess(res.data.subs));
            }).catch(error => {
            dispatch(subPackagesFail(error));
        });
    }
};

export const subPackagesListAdmin = (token, name, server) => {
    return dispatch => {
        dispatch(subPackagesLoading());
        axios.get('/admin/subpackages/' + name + '/' + server + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(subPackagesSuccess(res.data.subs));
            }).catch(error => {
            dispatch(subPackagesFail(error));
        });
    }
};

export const subPackagesListSuperReseller = (token, name, server) => {
    return dispatch => {
        dispatch(subPackagesLoading());
        axios.get('/superreseller/subpackages/' + name + '/' + server + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(subPackagesSuccess(res.data.subs));
            }).catch(error => {
            dispatch(subPackagesFail(error));
        });
    }
};

export const subPackagesListReseller = (token, name, server) => {
    return dispatch => {
        dispatch(subPackagesLoading());
        axios.get('/reseller/subpackages/' + name + '/' + server + '?token=' + token )
            .then(res => {
                console.log(res);
                dispatch(subPackagesSuccess(res.data.subs));
            }).catch(error => {
            dispatch(subPackagesFail(error));
        });
    }
};